import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82e2d422"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepCargo" }
const _hoisted_2 = {
  key: 0,
  class: "StepCargo__title"
}
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_4 = { class: "StepCargo__title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_6 = { class: "StepCargo__grid" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "StepCargo__grid mt-2" }
const _hoisted_9 = { class: "StepCargo__grid grid--triple mt-2" }
const _hoisted_10 = { class: "mt-2 grid grid-cols-3 gap-2" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_13 = { class: "text-sm mt-1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_15 = { class: "text-sm" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_17 = { class: "flex flex-col" }
const _hoisted_18 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_19 = { class: "text-sm mt-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_21 = { class: "text-sm" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_23 = { class: "flex flex-col" }
const _hoisted_24 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_25 = { class: "text-sm mt-1" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_27 = { class: "text-sm" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_29 = { class: "mt-2" }
const _hoisted_30 = { class: "grid grid-cols-3 gap-2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-blue-500" }, " Платная услуга ", -1))
const _hoisted_32 = {
  key: 0,
  class: "grid grid-cols-2 gap-2 mt-2"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "АВИА: можно отправлять батарейки/аккумуляторы, встроенные в устройство.", -1))
const _hoisted_34 = {
  key: 0,
  class: "mt-1 bg-red-50 text-red-500 border border-red-500 rounded-sm font-medium text-sm p-2"
}
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<ul class=\"list-disc list-inside\" data-v-82e2d422><li data-v-82e2d422>⁠отдельные батареи и аккумуляторы;</li><li data-v-82e2d422>Power Bank;</li><li data-v-82e2d422>аэрозоли и газы;</li><li data-v-82e2d422>легковоспламеняющиеся жидкости;</li><li data-v-82e2d422>⁠химические вещества;</li><li data-v-82e2d422>⁠взрывчатые вещества;</li><li data-v-82e2d422>токсичные и инфекционные вещества;</li><li data-v-82e2d422>радиоактивные материалы;</li><li data-v-82e2d422>⁠коррозионные вещества;</li><li data-v-82e2d422>другие товары, классифицируемые как опасные грузы.</li></ul>", 1)
const _hoisted_36 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_37 = {
  key: 0,
  class: "flex items-center cursor-pointer"
}
const _hoisted_38 = {
  key: 1,
  class: "fa fa-undo"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2 font-bold" }, " Верифицировать ", -1))
const _hoisted_40 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_41 = { key: 1 }
const _hoisted_42 = {
  key: 3,
  class: "mt-2"
}
const _hoisted_43 = { class: "flex flex-col" }
const _hoisted_44 = { class: "StepCargo__grid mt-2" }
const _hoisted_45 = { class: "flex flex-col" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-500 select-none" }, " Транспорт доставки ", -1))
const _hoisted_47 = { class: "mt-2" }
const _hoisted_48 = { class: "flex flex-col" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-500 select-none" }, " Кем будет производиться оплата ", -1))
const _hoisted_50 = { class: "mt-2" }
const _hoisted_51 = { class: "flex flex-col" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-500 select-none" }, " Способ оплаты за доставку ", -1))
const _hoisted_53 = {
  key: 1,
  class: "text-red-500 mt-3 text-sm font-medium"
}
const _hoisted_54 = { class: "flex items-center justify-end mt-3" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_loader = _resolveComponent("loader")!
  const _component_uploaded_file = _resolveComponent("uploaded-file")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_radio_group = _resolveComponent("radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isUpdate)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.stepNumber) + ". Оформите груз и оплату", 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            (_ctx.isUpdateInvoice)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Редактирование груза")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("Редактирование груза №" + _toDisplayString(_ctx.updatingCargoIndex + 1), 1)
                ], 64))
          ]),
          (!_ctx.isUpdateInvoice)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 0,
                class: "second text small",
                disabled: _ctx.disabled || _ctx.is_loading,
                onClick: _ctx.emitCancelUpdate
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createTextVNode(" Отменить редактирование ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true)
        ])),
    (_ctx.opened)
      ? (_openBlock(), _createElementBlock("form", {
          key: 2,
          class: "mt-3",
          onSubmit: _cache[36] || (_cache[36] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitSubmit && _ctx.emitSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_the_input, {
                class: "mt-2",
                placeholder: "Наименование товара",
                value: _ctx.state.product_name,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.product_name) = $event)),
                "is-invalid": _ctx.state_form$.product_name.$error,
                "validation-errors": _ctx.state_form$.product_name.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"]),
              _createVNode(_component_the_input, {
                class: "mt-2",
                placeholder: _ctx.customInvoiceNumberPlaceholder,
                value: _ctx.state.customer_invoice_number,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.customer_invoice_number) = $event)),
                "is-invalid": _ctx.state_form$.customer_invoice_number.$error,
                "validation-errors": _ctx.state_form$.customer_invoice_number.$errors
              }, null, 8, ["placeholder", "value", "is-invalid", "validation-errors"]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_the_input, {
                  placeholder: "Вес груза",
                  value: _ctx.state.weight,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.weight) = $event)),
                  "is-invalid": _ctx.state_form$.weight.$error,
                  "validation-errors": _ctx.state_form$.weight.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"]),
                _createVNode(_component_the_input, {
                  placeholder: "Количество мест",
                  value: _ctx.state.places,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.places) = $event)),
                  "is-invalid": _ctx.state_form$.places.$error,
                  "validation-errors": _ctx.state_form$.places.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_the_input, {
                  placeholder: "Длина (см)",
                  value: _ctx.state.depth,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.depth) = $event)),
                  "is-invalid": _ctx.state_form$.depth.$error,
                  "validation-errors": _ctx.state_form$.depth.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"]),
                _createVNode(_component_the_input, {
                  placeholder: "Ширина (см)",
                  value: _ctx.state.width,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.width) = $event)),
                  "is-invalid": _ctx.state_form$.width.$error,
                  "validation-errors": _ctx.state_form$.width.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"]),
                _createVNode(_component_the_input, {
                  placeholder: "Высота (см)",
                  value: _ctx.state.height,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.height) = $event)),
                  "is-invalid": _ctx.state_form$.height.$error,
                  "validation-errors": _ctx.state_form$.height.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_checkbox, {
                    label: "Обрешетка",
                    value: _ctx.additional_services.hasGrid,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.additional_services.hasGrid) = $event))
                  }, null, 8, ["value"]),
                  (_ctx.additionalServices.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, [
                          _createTextVNode(" Мин. " + _toDisplayString(_ctx.getValue('grid', 'minValue')) + " м", 1),
                          _hoisted_14
                        ]),
                        _createElementVNode("span", _hoisted_15, [
                          _createTextVNode(_toDisplayString(_ctx.getValue('grid', 'price')) + " тг/м", 1),
                          _hoisted_16
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_checkbox, {
                    label: "Паллета",
                    value: _ctx.additional_services.hasPallet,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.additional_services.hasPallet) = $event))
                  }, null, 8, ["value"]),
                  (_ctx.additionalServices.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, [
                          _createTextVNode(" Мин. " + _toDisplayString(_ctx.getValue('pallet', 'minValue')) + " м", 1),
                          _hoisted_20
                        ]),
                        _createElementVNode("span", _hoisted_21, [
                          _createTextVNode(_toDisplayString(_ctx.getValue('pallet', 'price')) + " тг/м", 1),
                          _hoisted_22
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_checkbox, {
                    label: "Мягкая упаковка",
                    value: _ctx.additional_services.hasSoftPackage,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.additional_services.hasSoftPackage) = $event))
                  }, null, 8, ["value"]),
                  (_ctx.additionalServices.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, [
                          _createTextVNode(" Мин. " + _toDisplayString(_ctx.getValue('soft_package', 'minValue')) + " м", 1),
                          _hoisted_26
                        ]),
                        _createElementVNode("span", _hoisted_27, [
                          _createTextVNode(_toDisplayString(_ctx.getValue('soft_package', 'price')) + " тг/м", 1),
                          _hoisted_28
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_the_textarea, {
                class: "mt-2",
                autoheight: "",
                rows: 4,
                placeholder: "Примечания к отправке",
                value: _ctx.state.annotation,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.annotation) = $event))
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_checkbox, {
                    label: "Возвратные документы",
                    value: _ctx.state.is_return_documents,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.is_return_documents) = $event)),
                    "return-integer": ""
                  }, null, 8, ["value"])
                ]),
                _hoisted_31,
                (!_ctx.isUpdateCreatedCargo && !_ctx.isUpdateInvoice && _ctx.state.shipment_type === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createVNode(_component_the_select, {
                        placeholder: "Наличие батарейки/аккумулятора",
                        value: _ctx.state.has_battery,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.has_battery) = $event)),
                        options: [{ id: 1, name: 'Да' }, { id: 2, name: 'Нет' }],
                        searchable: false,
                        "is-invalid": _ctx.state_form$.has_battery.$error,
                        "validation-errors": _ctx.state_form$.has_battery.$errors
                      }, null, 8, ["value", "is-invalid", "validation-errors"]),
                      _createVNode(_component_the_select, {
                        placeholder: "Наличие автозапчастей",
                        value: _ctx.state.has_auto_parts,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.has_auto_parts) = $event)),
                        options: [{ id: 1, name: 'Да' }, { id: 2, name: 'Нет' }],
                        searchable: false,
                        "is-invalid": _ctx.state_form$.has_auto_parts.$error,
                        "validation-errors": _ctx.state_form$.has_auto_parts.$errors
                      }, null, 8, ["value", "is-invalid", "validation-errors"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.has_battery === 1 && _ctx.state.shipment_type === 2)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", {
                        class: "mt-2 bg-red-50 text-red-500 border border-red-500 rounded-sm font-medium text-sm p-2 cursor-pointer flex items-center justify-between",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isAviaBlockedCargosDetailsShowed = !_ctx.isAviaBlockedCargosDetailsShowed))
                      }, [
                        _hoisted_33,
                        _createElementVNode("i", {
                          class: _normalizeClass(["fas fa-chevron-down transform transition-transform duration-300", { 'rotate-180': _ctx.isAviaBlockedCargosDetailsShowed }])
                        }, null, 2)
                      ]),
                      (_ctx.isAviaBlockedCargosDetailsShowed)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createTextVNode(" К авиа перевозке не принимаются опасные грузы, в том числе: "),
                            _hoisted_35
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (Boolean(_ctx.data_state.verify.type) || _ctx.data_state.verify.is_failed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      (_ctx.data_state.verify.is_failed)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            (_ctx.data_state.verify.is_loading)
                              ? (_openBlock(), _createBlock(_component_loader, {
                                  key: 0,
                                  class: "primary"
                                }))
                              : (_openBlock(), _createElementBlock("i", _hoisted_38)),
                            _hoisted_39
                          ]))
                        : (Boolean(_ctx.data_state.verify.type))
                          ? (_openBlock(), _createBlock(_component_checkbox, {
                              key: 1,
                              label: "Верифицировать",
                              value: _ctx.state.verify,
                              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.verify) = $event)),
                              "return-integer": ""
                            }, null, 8, ["value"]))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isUpdateInvoice)
                  ? (_openBlock(), _createBlock(_component_checkbox, {
                      key: 3,
                      class: "mt-3",
                      label: "Застраховать груз",
                      value: _ctx.state.is_ensure,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.is_ensure) = $event)),
                      "return-integer": ""
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.isUpdateInvoice)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    (_ctx.state.is_ensure)
                      ? (_openBlock(), _createBlock(_component_the_input, {
                          key: 0,
                          placeholder: "Наименование груза",
                          value: _ctx.state.cargo_name,
                          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.cargo_name) = $event)),
                          "is-invalid": _ctx.state_form$.cargo_name.$error,
                          "validation-errors": _ctx.state_form$.cargo_name.$errors
                        }, null, 8, ["value", "is-invalid", "validation-errors"]))
                      : _createCommentVNode("", true),
                    (_ctx.state.is_ensure)
                      ? (_openBlock(), _createBlock(_component_the_input, {
                          key: 1,
                          placeholder: "Объявленная стоимость",
                          value: _ctx.state.declared_price,
                          "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.declared_price) = $event)),
                          "is-invalid": _ctx.state_form$.declared_price.$error,
                          "validation-errors": _ctx.state_form$.declared_price.$errors
                        }, null, 8, ["value", "is-invalid", "validation-errors"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_checkbox, {
                class: "mt-3",
                label: "Опасный груз",
                value: _ctx.state.is_dangerous,
                "onUpdate:value": [
                  _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.is_dangerous) = $event)),
                  _ctx.onIsDangerousChange
                ],
                "return-integer": ""
              }, null, 8, ["value", "onUpdate:value"]),
              (_ctx.state.is_dangerous)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createVNode(_component_uploaded_file, {
                      "is-visible": _ctx.isInvoiceFiles,
                      files: _ctx.files_backend_state.invoice_files,
                      loading: _ctx.files_state.is_loading,
                      title: "Файлы накладной",
                      class: "my-5",
                      onDelete: _cache[20] || (_cache[20] = (value) => _ctx.deleteFile(value, 'invoice'))
                    }, null, 8, ["is-visible", "files", "loading"]),
                    _createVNode(_component_file_reader, {
                      class: "mt-3",
                      value: _ctx.files_state.invoice_files,
                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.files_state.invoice_files) = $event)),
                      placeholder: "Загрузите файл накладной",
                      disabled: _ctx.files_state.is_loading,
                      "is-invalid": _ctx.files_state_form$.invoice_files.$error,
                      "validation-errors": _ctx.files_state_form$.invoice_files.$errors,
                      accept: "all",
                      multiple: ""
                    }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
                    _createVNode(_component_uploaded_file, {
                      "is-visible": _ctx.isCertificate,
                      files: _ctx.files_backend_state.certificate_of_safety_files,
                      loading: _ctx.files_state.is_loading,
                      title: "Сертификаты безопасности",
                      class: "my-5",
                      onDelete: _cache[22] || (_cache[22] = (value) => _ctx.deleteFile(value, 'certificate'))
                    }, null, 8, ["is-visible", "files", "loading"]),
                    _createVNode(_component_file_reader, {
                      class: "mt-3",
                      value: _ctx.files_state.certificate_of_safety_files,
                      "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.files_state.certificate_of_safety_files) = $event)),
                      placeholder: "Загрузите сертификат безопасности",
                      disabled: _ctx.files_state.is_loading,
                      "is-invalid": _ctx.files_state_form$.certificate_of_safety_files.$error,
                      "validation-errors": 
                                _ctx.files_state_form$.certificate_of_safety_files.$errors
                            ,
                      accept: "all",
                      multiple: ""
                    }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isUpdateCreatedCargo && !_ctx.isUpdateInvoice && _ctx.state.shipment_type === 2)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_uploaded_file, {
                      "is-visible": _ctx.isMsds,
                      files: _ctx.files_backend_state.msds_files,
                      loading: _ctx.files_state.is_loading,
                      title: "Паспорт безопасности MSDS",
                      class: "my-5",
                      onDelete: _cache[24] || (_cache[24] = (value) => _ctx.deleteFile(value, 'msds'))
                    }, null, 8, ["is-visible", "files", "loading"]),
                    _createVNode(_component_file_reader, {
                      class: "mt-3",
                      value: _ctx.files_state.msds_file,
                      "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.files_state.msds_file) = $event)),
                      placeholder: "Паспорт безопасности MSDS (если имеется, просьба прикрепить)",
                      accept: ".pdf,.jpg,.png,.docx",
                      disabled: _ctx.files_state.is_loading
                    }, null, 8, ["value", "disabled"])
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_checkbox, {
                class: "mt-3",
                label: "Температурный режим",
                value: _ctx.state.is_temperature_regime_active,
                "onUpdate:value": [
                  _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.is_temperature_regime_active) = $event)),
                  _ctx.onTemperatureRegimeChanged
                ]
              }, null, 8, ["value", "onUpdate:value"]),
              (_ctx.state.is_temperature_regime_active)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createVNode(_component_the_select, {
                      placeholder: "Температурный режим",
                      value: _ctx.state.temperature_regime_type_id,
                      "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.temperature_regime_type_id) = $event)),
                      options: _ctx.data_state.temperature_regimes.list,
                      loading: _ctx.data_state.temperature_regimes.is_loading,
                      failed: _ctx.data_state.temperature_regimes.is_failed,
                      "error-text": "При получении списка температурных режимов произошла ошибка",
                      "infinite-scroll": "",
                      searchable: false,
                      label: "title",
                      "is-invalid": _ctx.state_form$.temperature_regime_type_id.$error,
                      "validation-errors": _ctx.state_form$.temperature_regime_type_id.$errors,
                      onRefresh: _ctx.loadTemperatureRegimes
                    }, null, 8, ["value", "options", "loading", "failed", "is-invalid", "validation-errors", "onRefresh"]),
                    _createVNode(_component_uploaded_file, {
                      "is-visible": _ctx.isTemperature,
                      files: _ctx.files_backend_state.temperature_regime_safety_files,
                      loading: _ctx.files_state.is_loading,
                      title: "Паспорты безопасности",
                      class: "my-5",
                      onDelete: _cache[28] || (_cache[28] = (value) => _ctx.deleteFile(value, 'temperature'))
                    }, null, 8, ["is-visible", "files", "loading"]),
                    _createVNode(_component_file_reader, {
                      class: "mt-3",
                      value: _ctx.files_state.temperature_regime_safety_files,
                      "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.files_state.temperature_regime_safety_files) = $event)),
                      placeholder: "Загрузите паспорт безопасности",
                      disabled: _ctx.state.is_loading,
                      "is-invalid": _ctx.files_state_form$.temperature_regime_safety_files.$error,
                      "validation-errors": 
                                _ctx.files_state_form$.temperature_regime_safety_files.$errors
                            ,
                      accept: "all",
                      multiple: ""
                    }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_the_input, {
                class: "mt-3",
                placeholder: "Наложенный платёж",
                maska: _ctx.PRICE_MASK,
                value: _ctx.state.cod_payment,
                "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.cod_payment) = $event))
              }, null, 8, ["maska", "value"])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createVNode(_component_radio_group, {
                    name: "shipment_type",
                    value: _ctx.state.shipment_type,
                    "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.shipment_type) = $event)),
                    options: _ctx.ltlShipmentTypes,
                    class: "small mt-2",
                    onChange: _ctx.onChangeShipmentType
                  }, null, 8, ["value", "options", "onChange"])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createVNode(_component_radio_group, {
                    name: "payment_type",
                    value: _ctx.state.payment_type,
                    "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.payment_type) = $event)),
                    options: _ctx.PAYMENT_TYPE_OPTIONS,
                    onChange: _ctx.onPaymentTypeChange,
                    class: "small mt-2"
                  }, null, 8, ["value", "options", "onChange"]),
                  (_ctx.isOnPayerSelect)
                    ? (_openBlock(), _createBlock(_component_the_select, {
                        key: 0,
                        value: _ctx.state.payer_company_id,
                        "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.payer_company_id) = $event)),
                        placeholder: "Плательщик",
                        label: "name",
                        "is-invalid": _ctx.state_form$.payer_company_id.$error,
                        loading: _ctx.data_state.payers.is_loading,
                        failed: _ctx.data_state.payers.is_failed,
                        disabled: _ctx.isPayerSelectDisabled,
                        "error-text": "При получении списка компаний произошла ошибка",
                        options: _ctx.data_state.payers.list,
                        "infinite-scroll": "",
                        onRefresh: _ctx.loadPayers,
                        class: "mt-2",
                        onChange: _ctx.onPayerSelect
                      }, null, 8, ["value", "is-invalid", "loading", "failed", "disabled", "options", "onRefresh", "onChange"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createVNode(_component_radio_group, {
                    red: _ctx.isSelectedThirdFaceChl,
                    name: "payment_method",
                    value: _ctx.state.payment_method,
                    "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.payment_method) = $event)),
                    options: _ctx.getPaymentMethods,
                    onChange: _ctx.onPaymentMethodChange,
                    class: "small mt-2"
                  }, null, 8, ["red", "value", "options", "onChange"]),
                  (_ctx.isCanInputCash)
                    ? (_openBlock(), _createBlock(_component_the_input, {
                        key: 0,
                        placeholder: "Сумма наличными",
                        value: _ctx.state.cash_sum,
                        "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state.cash_sum) = $event)),
                        "is-invalid": _ctx.state_form$.cash_sum.$error,
                        "validation-errors": _ctx.state_form$.cash_sum.$errors
                      }, null, 8, ["value", "is-invalid", "validation-errors"]))
                    : _createCommentVNode("", true),
                  (_ctx.isSelectedThirdFaceChl)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_53, "Данный выбор невозможен, ЧЛ - не может оплачивать перечислением на счет"))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createVNode(_component_the_button, {
              type: "submit",
              disabled: _ctx.disabled || _ctx.is_loading,
              class: "primary text small",
              loading: _ctx.is_loading
            }, {
              default: _withCtx(() => [
                _hoisted_55,
                _createTextVNode(" Подтвердить ")
              ]),
              _: 1
            }, 8, ["disabled", "loading"])
          ])
        ], 32))
      : _createCommentVNode("", true)
  ]))
}